import { FilterBar, FormGroup, Label, TextField, Select } from '@celltrak/ui-components';

import useVisitFilterBar from './hooks';

function RejectedFilterBar() {
  const {
    partnersOptions,
    agencyOptions,
    showResetButton,
    handleFilterChanges,
    handleResetFilter,
    handleEnterPress,
    filters,
  } = useVisitFilterBar();

  return (
    <FilterBar
      onPrimaryClick={handleResetFilter}
      buttonSize="sm"
      showPrimaryButton={showResetButton}
      showSecondaryButton={false}
      primaryButtonLabel="Reset"
    >
      <FormGroup>
        <Label for="first-received-on" size="sm">
          First Received On
        </Label>
        <TextField
          id="first-received-on"
          size="sm"
          placeholder="YYYY-MM-DD"
          value={filters.firstReceivedOn}
          onChange={handleFilterChanges('firstReceivedOn')}
          onKeyPress={handleEnterPress}
        />
      </FormGroup>
      <FormGroup>
        <Label for="last-received-on" size="sm">
          Last Received On
        </Label>
        <TextField
          id="last-received-on"
          size="sm"
          placeholder="YYYY-MM-DD"
          value={filters.lastReceivedOn}
          onChange={handleFilterChanges('lastReceivedOn')}
          onKeyPress={handleEnterPress}
        />
      </FormGroup>
      <FormGroup>
        <Label for="partner-filter" size="sm">
          Partner
        </Label>
        <Select
          id="partner-filter"
          size="sm"
          options={partnersOptions}
          value={filters.partnerID}
          onChange={handleFilterChanges('partnerID')}
        />
      </FormGroup>
      <FormGroup>
        <Label for="agency-filter" size="sm">
          Agency
        </Label>
        <Select
          id="agency-filter"
          size="sm"
          options={agencyOptions}
          value={filters.agencyID}
          onChange={handleFilterChanges('agencyID')}
        />
      </FormGroup>
      <FormGroup>
        <Label for="reference-number-filter" size="sm">
          Reference Number
        </Label>
        <TextField
          id="reference-number-filter"
          size="sm"
          placeholder="Search..."
          value={filters.referenceNumber}
          onChange={handleFilterChanges('referenceNumber')}
          onKeyPress={handleEnterPress}
        />
      </FormGroup>
    </FilterBar>
  );
}

export default RejectedFilterBar;
